<template>
  <div class="row px-4">
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.active"
        :label="$t('questions.active')"
        name="active"
        :options="localizedYesNo"
        :readonly="readonly"
        :error="errors.ACTIVE"
      />
    </div>
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.goal"
        :label="$t('questions.goal')"
        name="goal"
        :readonly="readonly"
        :error="errors.GOAL"
        :options="localizedGoalOptions"
        :stacked="true"
        />
    </div>
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <options
        v-model="applicationData.current_services"
        :label="$t('questions.current_services')"
        name="current_services"
        :readonly="readonly"
        :options="localizedCurrentServicesOptions"
        :stacked="true"
        :error="$t('required')"
      />
    </div>
    <div v-show="isOther" class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="200">
      <text-field
        v-model="applicationData.explain_other_jobs"
        name="explanation"
        :readonly="readonly"
        :rules="{ required: isOther, min: 10 }"
      />
    </div>
    <more-info />
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import Question from '@/shared/fields/cleaner_app_form_question.vue'
import Options from '@/shared/fields/cleaner_app_form_options.vue'
import TextField from '@/shared/inputs/text_area.vue'
import MoreInfo from './more_info.vue'

export default {
  components: {
    Question, TextField, MoreInfo, Options
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      errors: $errors,
      options: $options
    }
  },
  computed: {
    localizedYesNo() {
      return [ this.$t('yes'), this.$t('no') ]
    },
    isOther() {
      if (this.applicationData.current_services) {
        return this.applicationData.current_services.includes(this.$t('options.current_services.other'))
      }
    },
    localizedGoalOptions() {
      let options = []
      this.options.GOAL.forEach((key) => {
        options.push(this.$t('options.goal.' + key))
      })
      return options
    },
    localizedCurrentServicesOptions() {
      let options = []
      this.options.CURRENT_SERVICES.forEach((key) => {
        options.push(this.$t('options.current_services.' + key))
      })
      return options
    },
  },
  methods: {

  }
}
</script>
